<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  collegeClassListMethod,
  collegeClassComputed,
  collegeComputed,
  collegeListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      classCode: '',
      collegeError: null,
      isCollegeError: false,
      collegeSuccess: '',
      isCollegeSuccess: false,
      isLoading: false,
      show: false,
      platformId: 0,
      departmentlist: [],
      departmentId: null,
      collegelist: [],
      collegeId: null,
    }
  },
  computed: {
    ...authComputed,
    ...collegeClassComputed,
    ...collegeComputed,
    ...departmentComputed,
  },
  mounted() {
    this.platformId = this.currentUser.user.platform_id
    if (this.role === 'administrator') {
      this.getColleges()
    }
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
    }
    this.getDepartments()
  },
  methods: {
    ...collegeClassListMethod,
    ...departmentListMethod,
    ...collegeListMethod,

    updateCollegeClass() {
      this.isLoading = true
      const Data = {
        id: this.data._id,
        name: this.name,
        classCode: this.classCode,
        college_id: this.collegeId,
        department: this.departmentId,
      }
      this.updateCollegeClassData({ Data })
        .then((resp) => {
          this.isLoading = false
          this.collegeSuccess = 'Class Updated Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.collegeError = getError.message
          this.isCollegeError = true
        })
    },

    getData() {
      this.name = this.data.name
      this.classCode = this.data.classCode
      this.collegeId = this.data.college_id
      this.getDepartments()
      this.departmentId = this.data.department
    },

    resetModal() {
      this.isCollegeError = false
      this.name = this.data.name
      this.classCode = this.data.classCode
      this.departmentId = this.data.department_id
      this.collegeId = this.data.college_id
    },

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            listitems.push(ele)
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="collegeclass-update-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isCollegeError"
          variant="danger"
          v-html="collegeError"
        ></b-alert>
        <b-alert
          v-model="isCollegeSuccess"
          variant="success"
          v-html="collegeSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateCollegeClass">
          <b-form-group
            v-if="role === 'administrator'"
            label="College"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeId"
              :options="collegelist"
              @change="getDepartments"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Department" label-for="input-1">
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Class Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              placeholder="Enter Class Name"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Class Code" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="classCode"
              type="text"
              placeholder="Enter Class Code"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
